import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const AlignCenter = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.83301 4.33325C2.55687 4.33325 2.33301 4.55711 2.33301 4.83325C2.33301 5.10939 2.55687 5.33325 2.83301 5.33325H14.1663C14.4425 5.33325 14.6663 5.10939 14.6663 4.83325C14.6663 4.55711 14.4425 4.33325 14.1663 4.33325H2.83301ZM2.33301 8.49992C2.33301 8.22378 2.55687 7.99992 2.83301 7.99992H14.1663C14.4425 7.99992 14.6663 8.22378 14.6663 8.49992C14.6663 8.77606 14.4425 8.99992 14.1663 8.99992H2.83301C2.55687 8.99992 2.33301 8.77606 2.33301 8.49992ZM4.99967 12.1666C4.99967 11.8904 5.22353 11.6666 5.49967 11.6666H11.4997C11.7758 11.6666 11.9997 11.8904 11.9997 12.1666C11.9997 12.4427 11.7758 12.6666 11.4997 12.6666H5.49967C5.22353 12.6666 4.99967 12.4427 4.99967 12.1666Z"
            fill={color}
          />
        </svg>
      </svg>
    )
  },
)

export default AlignCenter
